import React, { PureComponent } from 'react';

class InputSalesChannel extends PureComponent {
    render() {

        const { Cuenta, guardarCampoCuenta } = this.props;

        return (
        <div className="bottom-separator-xs">
            <div className="row">
                <div className="col-md-12">
                    <label className="label-primary">Canal de venta </label><label className="label-secondary">(opcional)</label>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <input type="text" className="form-control default-input"
                            value={Cuenta.CanalVentaVisaCodigo}
                            onChange={(event) => {
                                guardarCampoCuenta(event.target.value, "CanalVentaVisaCodigo")
                            }} />
                    </div>
                </div>
                <div className="col-md-6"></div>
            </div>
        </div>
        );
    }
}

export default InputSalesChannel;